import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { UserComponent } from './user/user.component'
import { UserRoutingModule } from './user.routing.module'
import { CommonCompModule } from '../common/common.module'
import { TranslateModule } from '@ngx-translate/core'
import { UserFormComponent } from './user-form/user-form.component'
import { LatitudeAltModule } from '../latitude/latitude.module'

const components = [UserComponent, UserFormComponent]

@NgModule({
  imports: [
    CommonModule,
    UserRoutingModule,
    CommonCompModule,
    LatitudeAltModule,
    TranslateModule,
  ],
  declarations: [...components],
  exports: [...components],
})
export class UserModule {}
